import { createSelector } from '@reduxjs/toolkit';
import { selectScreenSize } from 'store/slice/screen';
import { selectOfferSelected } from 'component/page/detail/store/availabilityDEPRECATED.selectors';
import { FooterType } from 'component/page/detail/DetailPageContent/DetailPageContent.selectors';
import { FooterVariant } from 'component/page/detail/DetailPageModularize/detailPageModularize.types';

interface OwnProps {
    variant: FooterVariant;
}

export interface StateProps {
    footerType: FooterType;
    isSelectedOfferCardExist: boolean;
}

export type FooterComponentProps = OwnProps & StateProps;

export const mapStateToProps = createSelector(selectScreenSize, selectOfferSelected, (screenSize, selectedOffer): StateProps => {
    const isSelectedOfferCardExist = selectedOffer?.offerIndex !== undefined && selectedOffer?.offerIndex > -1;
    const footerType = isSelectedOfferCardExist ? (screenSize.desktop ? FooterType.None : FooterType.Booking) : FooterType.Details;
    return {
        footerType,
        isSelectedOfferCardExist,
    };
});
